import React from 'react';
const Divider = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
  style: {
    clear: 'both'
  }
}), /*#__PURE__*/React.createElement("hr", null));
export default Divider;